import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { createSelector, Store } from '@ngxs/store';

import { LocationSelectors } from 'src/app/store/location/location.selectors';
import { AddTicketMealPlan } from 'src/app/store/tickets/tickets.action';
import { NormalizedDiner } from 'src/app/models';
import { DinersSelectors } from 'src/app/store/diners/diners.selectors';
import { TicketsStateSelectors } from 'src/app/store/tickets/tickets.selectors';

class PageSelector {
  static mealPlanDiner = createSelector(
    [DinersSelectors.dinersById, TicketsStateSelectors.normalizedTicket],
    (dinersById, { diner_id, guest_of_diner_id }) =>
      dinersById[diner_id || guest_of_diner_id]
  );
}

@Component({
  templateUrl: './meal-plan.modal.html',
  styleUrls: ['./meal-plan.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MealPlanModal {
  @ViewSelectSnapshot(PageSelector.mealPlanDiner)
  readonly diner: NormalizedDiner;
  @ViewSelectSnapshot(LocationSelectors.getIsServiceAppointment)
  readonly isServiceAppointment: boolean;

  constructor(
    private readonly modalController: ModalController,
    private readonly store: Store
  ) {}

  onPayForMeal() {
    this.modalController.dismiss();
  }

  onUseMealPlan(mealPlanId: number) {
    this.store.dispatch(
      new AddTicketMealPlan({
        mealPlanId,
        ticketUuid: this.store.selectSnapshot(
          TicketsStateSelectors.selectedTicketId
        )
      })
    );
    this.modalController.dismiss();
  }
}
